import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./routes/routes";
import "./App.css";
import { AuthProvider } from "./contexts/authContext";
import { LoaderProvider } from "./contexts/loaderContext";
import NotificationProvider from "./contexts/notificationContext";
import { BrandingProvider } from "./contexts/brandingContext";
function App() {
  return (
    <NotificationProvider>
      <BrowserRouter>
        <LoaderProvider>
          <AuthProvider>
            <BrandingProvider>
            <AppRoutes />
            </BrandingProvider>
          </AuthProvider>
        </LoaderProvider>
      </BrowserRouter>
    </NotificationProvider>
  );
}

export default App;
